module.exports = __webpack_public_path__ + "img/promobox_02m.744f7b20.svg";